import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { useState } from 'react';
import { gql } from '@/__generated__';
import {
  AiFilterSuggestion,
  MutationAiFilterWithAssistantArgs,
} from '@/__generated__/schema-types';

const GET_AI_FILTER_SUGGESTION = gql(`
  mutation GetAiFilterSuggestion($prompt: String!, $chatId: ID) {
    aiFilterWithAssistant(prompt: $prompt, chatId: $chatId) {
      chatId
      prompt
      responseType
    }
  }
`);

export type AiAssistantHistoryItem =
  | AiFilterSuggestion
  | { prompt: string; isUserMessage: true };

export function useAiAssistant() {
  const toast = useToast();
  const [aiAssistantHistory, setAiAssistantHistory] = useState<
    Array<AiAssistantHistoryItem>
  >([]);

  const [getFilterSuggestion, { loading, data }] = useMutation(
    GET_AI_FILTER_SUGGESTION,
    {
      onError: () => {
        toast.error({
          title: 'Failed to get AI filter suggestion',
          subTitle: 'Please try again',
        });
      },
      onCompleted: (data) => {
        setAiAssistantHistory([
          ...aiAssistantHistory,
          data.aiFilterWithAssistant,
        ]);
      },
    },
  );

  const getSuggestion = async ({
    prompt,
    chatId,
  }: MutationAiFilterWithAssistantArgs) => {
    setAiAssistantHistory([
      ...aiAssistantHistory,
      { prompt, isUserMessage: true },
    ]);
    return getFilterSuggestion({
      variables: {
        prompt,
        chatId,
      },
    });
  };

  return {
    aiAssistantHistory,
    getSuggestion,
    loading,
    suggestion: data?.aiFilterWithAssistant,
  };
}
